/**
 * Client-side money formatter for live estimates only (cart, qty changes).
 * The server is always authoritative for persisted amounts — it sends a
 * pre-formatted `Money.formatted` string with every product/order payload.
 *
 * Amounts are whole Algerian Dinar (no centimes used in retail); we render two
 * decimals to match the storefront convention, e.g. 7000 -> "7000.00DA".
 */
export function formatDA(dinars: number, currencySuffix = 'DA'): string {
  return `${dinars.toFixed(2)}${currencySuffix}`
}
